var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"overlay-body",attrs:{"opacity":_vm.overlay.opacity,"show":_vm.overlay.visible,"rounded":"sm"}},[_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }